<template>
    <div>
        <div class="saving" v-if="saving">
            <LoadingSpinner :loading="saving"/>
        </div>
        <div class="loading" v-if="loading">
            <LoadingSpinner :loading="loading"/>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <Calculation v-model="calculation" :edit="true" :create="false"></Calculation>
            </div>
            <div class="col-12 text-center mt-3 mb-3">
                <button class="btn btn-primary" @click="save">Uložit</button>
            </div>
        </div>
    </div>
</template>

<script>
import Calculation from '@/components/Calculation.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        LoadingSpinner
    },
    data() {
        return {
            calculation: {},
            saving: false,
            loading: true
        }
    },
    created: function () {
        this.load();
    },
    methods: {
        load: function () {
            this.loading = true;
            this.$store.getters.api.get("/calculation/" + this.$route.params.slug).then(function (response) {
                this.calculation = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        save: function () {
            this.saving = true;
            this.$store.getters.api.put("/calculation/" + this.$route.params.slug + "/edit",
                { "calculation": this.calculation }
            ).then(function () {
                this.saving = false;
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>